// Wording for domain verification, shared by the company and domain pages.

export const DOMAIN_STATUS = {
  verified: { tone: 'good', label: 'Verified' },
  unverified: { tone: 'warn', label: 'Not verified' },
  expired: { tone: 'warn', label: 'Needs renewing' },
  superseded: { tone: 'bad', label: 'Claimed by another company' },
};

export const REQUEST_STATUS = {
  pending: { tone: 'info', label: 'Waiting' },
  approved: { tone: 'good', label: 'Approved' },
  declined: { tone: 'bad', label: 'Declined' },
  expired: { tone: 'neutral', label: 'Expired' },
  cancelled: { tone: 'neutral', label: 'Replaced' },
  failed: { tone: 'bad', label: 'Couldn’t send' },
};
